import WYSIWYG from './WYSIWYG'
export default WYSIWYG